import React, { useState } from 'react'
// import { Spinner } from 'react-bootstrap'
import AddCard from './AddCard'
import '../styles/allmiddlepagesdesign.css'
import CircularProgress from '@mui/material/CircularProgress'

import { Grid, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogContentText, Box} from '@mui/material'


// import { MDBSpinner } from 'mdb-react-ui-kit';

export function AreYouSure ({open, close, handleDeletedOpen, index, deleteCard}) {
 
    console.log(index)
  
    return (
      <Dialog
          open={open}
          onClose={close}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent >
              <DialogContentText id="alert-dialog-description" >
              ARE YOU SURE!
            </DialogContentText>
  
           
          </DialogContent>
         
              
            <Box sx={{ textAlign: "center", padding: "10px"}}>
                <Button sx={{color: "red"}} onClick={close}>No</Button>
                <Button sx={{color: "green"}} onClick={() => {
                close()
                deleteCard(index)
                handleDeletedOpen()
                //   handleDeletedOpen()
                }}>Yes</Button>
            
            </Box>
          
          
        </Dialog>
    )
  }


export default function InputCard(props) {
    const { userDetails, handleSubmit, deleteCard, accountLoader, handleClickOpen, handleDeletedOpen } = props
    console.log(props.Loader)

    const [show, setShow] = useState(false)

    const [areYouSure, setAreYouSure ] = useState(false)
    const handleAreYouSureOpen = () => {
        setAreYouSure(true);
      };

      const handleAreYouSureClose = () => {
        setAreYouSure(false);
      };

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    const rows = userDetails.map((row, index) => {
        return (
           <>
            <Grid item xs={12} sm={6} md={4}>
                <Card >
                    <Button onClick={() => {
                        handleAreYouSureOpen()
                    }}
                    >Delete </Button>
                    <CardContent>
                        <p> <span>Currency:</span> {row.accountCurrency}</p>
                        <p> <span>Acct No:</span> {row.bankNumber}</p>
                        <p> <span>Acct Name:</span> {row.accountName}</p>
                        <p> <span> Bank:</span> {row.recipientBank}</p>
                    </CardContent>
                </Card>
            </Grid>

            <AreYouSure 
            open={areYouSure}
            index={index}
            deleteCard={deleteCard}
            handleDeletedOpen={handleDeletedOpen}
            close={handleAreYouSureClose}
            />
           </>

        )
    })


    return (

        <Grid container sx={{ p: '20px' }} spacing={2} >
            <Grid item justifyContent="center" container xs={12}>
                <Card sx={{ width: { xs: '100%', sm: "300px" }, height: '200px' }}>
                    <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }} onClick={handleShow}>
                        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" /></svg>
                    </CardContent>

                    <Dialog open={show} onClose={handleClose}>
                        <DialogTitle closeButton>
                                <h3>Add a recipient </h3>
                                <p style={{ fontSize: '10px' }}>Kindly add a recipient account details</p>
                        </DialogTitle>
                        <DialogContent>
                            <AddCard
                                handleSubmit={handleSubmit} handleClose={handleClose} accountLoader={accountLoader} handleClickOpen={handleClickOpen} />
                        </DialogContent>
                    </Dialog>
                </Card>

            </Grid>


            {props.Loader ? rows : <CircularProgress />}

        </Grid>

    )
}
